// ============================================================
// urun_usd_fiyat.js — ANA mağaza (Shopify)
// Ne yapar: <sale-price> / <compare-at-price> öğelerinin altına fiyatın
//   KDV HARİÇ USD karşılığını "$X.XX + KDV (%20)" olarak ekler; sonradan
//   yüklenen öğeler için MutationObserver kullanır.
// Hesap: sitedeki TL fiyat KDV dahil → TL / exchangeRate = KDV dahil USD → / 1.20 = KDV hariç USD.
// Değişiklik (17.09.2026): önceden KDV dahil USD gösteriyordu; dental sürümdeki
//   (dental_urun_usd_fiyat.js) gibi "fiyat + KDV" biçimine geçildi.
// Kur sabit: exchangeRate'i güncellemek yeterli.
// ============================================================

// 1. Döviz kuru ve KDV oranı
const exchangeRate = 49.7;  // ← TL başına 1 USD kuru, burayı güncellemen yeterli
const kdvRate = 0.20;     // %20 KDV

// 2. TL fiyat metnini KDV hariç USD'ye çevir
function convertTLtoUSD_Net(priceText) {
  const cleaned = priceText
    .replace(/[^\d.,]/g, '')   // Sadece sayı, nokta, virgül
    .replace(/,/g, '');        // Binlik virgül varsa sil
  const priceTL = parseFloat(cleaned);
  if (isNaN(priceTL)) return null;

  const usdBrut = priceTL / exchangeRate;   // KDV dahil USD
  return usdBrut / (1 + kdvRate);           // KDV hariç USD
}

// 3. USD fiyatı ilgili DOM elemanına ekle
function addUSDPrice(el) {
  if (el.querySelector('.usd-price')) return;

  const priceText = el.textContent.trim();
  const usdNet = convertTLtoUSD_Net(priceText);
  if (!usdNet) return;

  const usdElement = document.createElement('div');
  usdElement.className = 'usd-price';
  usdElement.style.fontSize = '0.85em';
  usdElement.style.color = 'gray';
  usdElement.textContent = usdNet.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }) + ' + KDV (%20)';

  el.appendChild(usdElement);
}

// 4. Sayfa yüklendiğinde ve yeni içerikler eklendiğinde USD fiyatları ekle
function initUSDPrices() {
  document.querySelectorAll('sale-price, compare-at-price').forEach(el => {
    addUSDPrice(el);
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('sale-price, compare-at-price')) {
          addUSDPrice(node);
        }

        node.querySelectorAll?.('sale-price, compare-at-price')?.forEach(el => {
          addUSDPrice(el);
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// 5. Sayfa yüklendiğinde başlat
document.addEventListener('DOMContentLoaded', initUSDPrices);
